import {
    Modal,
    ModalContent,
    ModalBody,
    ModalOverlay,
    Progress,
    Stack,
    Flex,
    Text
} from "@chakra-ui/react"

const ModalLoading = ({ isOpen, onClose, message }) => {
    //console.log("modal : " + isOpen)
    return (
        <Modal isOpen={isOpen} onClose={onClose} closeOnEsc={false} closeOnOverlayClick={false} motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalBody>
                    <Stack p={2} spacing={2}>
                        <Progress size="xs" isIndeterminate />
                        <Flex w="full" justify="center">
                            <Text>{message || `กรุณารอสักครู่...`}</Text>
                        </Flex>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ModalLoading
